var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7855 0.765047L74.4577 0.000696896C74.4577 0.000696896 65.0734 -0.155924 59.1843 4.22676C52.5161 9.18913 50.0067 15.5149 43.1882 19.482C36.3696 23.4492 29.1641 24.1776 29.1641 24.1776V62.4084L75.7855 0.765047Z",
    fill: "#5DA52D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5126 4.99238C53.8444 9.95495 51.335 16.2805 44.5164 20.2477C37.6977 24.2148 30.4922 24.9432 30.4922 24.9432V63.174C30.4922 63.174 37.6977 62.4456 44.5164 58.4785C51.335 54.5113 53.8442 48.1858 60.5126 43.2232C66.4015 38.8405 75.786 38.9971 75.786 38.9971V0.766322C75.7859 0.766322 66.4015 0.609701 60.5126 4.99238Z",
    fill: "#7ACA45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5828 22.8516L23.2109 23.6385V96.9403L23.2127 96.9401C23.2169 97.4912 23.5501 98.0171 24.2315 98.4104C25.7453 99.2844 28.3895 99.1748 30.1373 98.1656C31.106 97.6064 31.594 96.8883 31.5807 96.2102L31.5828 96.21V22.8516Z",
    fill: "#C2CDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1387 24.8122C31.8866 23.8031 32.0765 22.2765 30.5627 21.4025C29.0489 20.5285 26.4047 20.6382 24.6569 21.6473C22.909 22.6565 22.7191 24.183 24.2329 25.057C25.7467 25.931 28.3907 25.8214 30.1387 24.8122Z",
    fill: "#667790"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.243 30.9597L69.4908 29.5116L71.2239 33.3988L59.4347 38.6552L57.7015 34.768L61.6909 32.9893L58.008 24.7291C57.944 25.0438 57.661 25.3948 57.1592 25.782C56.6745 26.1617 56.1934 26.4579 55.7161 26.6708L54.6164 27.1611L52.8833 23.2739L53.9829 22.7836C54.8354 22.4036 55.4043 21.9148 55.6898 21.3175C55.9924 20.7125 56.0037 19.8899 55.7239 18.8497L59.9946 16.9456L66.243 30.9597Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7954 39.386L53.0899 41.484L50.3259 38.5163L44.4696 41.1274L44.8298 45.1669L40.0987 47.2763L38.7918 26.399L43.1393 24.4607L57.7954 39.386ZM44.1119 36.7497L47.3085 35.3244L46.7107 34.6712C45.538 33.416 44.4486 32.1645 43.4426 30.9167C43.6643 32.5142 43.8586 34.1648 44.0256 35.8685L44.1119 36.7497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.1ecc20080ce07763938eec8907d41443.svg";
export { ForwardRef as ReactComponent };